import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { TaskExcludedIds } from '../types';

export const taskExcludedIdsLoaders = getLoaders({
  taskExcludedIds: {
    load: async ({
      projectId,
      taskId,
    }: {
      projectId: string;
      taskId: string;
    }): Promise<TaskExcludedIds> => {
      return executeApiCall({
        path: `/projects/${projectId}/${taskId}/excluded-ids`,

        method: 'get',
      });
    },
  },
});
